module.exports = __webpack_public_path__ + "static/media/mail-icon.0247a8c0.svg";